import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ssoAutoLogin } from "../utils/ssoAutoLogin";
import { useUser } from "../context/UserContext";
import { supabase } from "../supabaseClient";


export default function AuthSuitePage() {
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { setCurrentUser, refreshUser } = useUser();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const suiteToken = params.get("suite_token");
    const loginHint = params.get("login_hint");
    const userName = params.get("user_name");
    const userRole = params.get("user_role");

    if (!suiteToken) {
      setError("No suite token provided.");
      return;
    }

    // Strip token from URL
    window.history.replaceState({}, document.title, "/auth/suite");

    ssoAutoLogin(suiteToken, loginHint, userName, userRole)
      .then(async (data) => {
        if (data && data.user) {
          
          if (data.token_hash && data.verification_type) {
            const { error: otpError } = await supabase.auth.verifyOtp({
              token_hash: data.token_hash,
              type: data.verification_type
            });
            if (otpError) {
              console.error("Supabase session verification failed:", otpError);
              throw new Error("Failed to establish secure session");
            }
          }

          // Format user to match existing structure (fallback if refreshUser fails)
          const profile = data.user;
          const allowedTeamIds = [profile.team_id, ...(profile.sub_team_ids || [])].filter(Boolean);
          const adminDeptIds = [profile.role === "Department Admin" ? profile.department_id : null].filter(Boolean);

          const userObj = {
            id: profile.id,
            name: profile.name,
            email: profile.email,
            role: profile.role || "User",
            team_id: profile.team_id || null,
            sub_team_ids: profile.sub_team_ids || [],
            photo_url: profile.photo_url || null,
            department_id: profile.department_id || null,
            is_active: profile.is_active !== false,
            can_manage_users: profile.can_manage_users || false,
            can_manage_teams: profile.can_manage_teams || false,
            memberships: [],
            allowedTeamIds: [...new Set(allowedTeamIds)],
            adminDeptIds: [...new Set(adminDeptIds)]
          };

          setCurrentUser(userObj);
          
          // Attempt to refresh user fully from the new Supabase session
          const { data: { session } } = await supabase.auth.getSession();
          if (session?.user) {
            await refreshUser(session.user);
          }

          const redirectUrl = localStorage.getItem("redirect_after_login");
          if (redirectUrl) {
            localStorage.removeItem("redirect_after_login");
            navigate(redirectUrl);
          } else {
            navigate("/");
          }
        } else {
          setError("Failed to auto login. Invalid data.");
        }
      })
      .catch((err) => {
        setError(err.message || "SSO Login failed");
      });
  }, [location, navigate, setCurrentUser, refreshUser]);

  if (error) {
    return <div style={{ padding: 20, color: "red", textAlign: "center", marginTop: "100px" }}>{error}</div>;
  }

  return <div style={{ padding: 20, textAlign: "center", marginTop: "100px" }}>Logging you in via AGS Suite...</div>;
}
